document.addEventListener("DOMContentLoaded", function () {
    let fieldId = "3_16"; // Replace underscore with a hyphen
    let checkboxes = document.querySelectorAll(
        "#field_" + fieldId + ' input[type="checkbox"]'
    );

    checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener("change", function () {
        limitCheckboxSelection(checkboxes, checkbox);
        });
    });
});

function limitCheckboxSelection(checkboxes, selectedCheckbox) {
    checkboxes.forEach(function (checkbox) {
        if (checkbox !== selectedCheckbox && checkbox.checked) {
        checkbox.checked = false;
        }
    });
}
